import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RetoPcPage } from '../reto-pc/reto-pc';
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';
import { DesafioPersonalProvider } from '@providers/desafio-personal/desafio-personal';

@IonicPage()
@Component({
  selector: 'page-cargador-pc',
  templateUrl: 'cargador-pc.html',
})
export class CargadorPcPage {

  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;

  count: number = 3;
  interval: any;

  jugador: Jugador = new Jugador;
  equipo: Equipo = new Equipo;

  juego: any = {};
  
  bot: any;

  score: number = 0;

  readonly AUDIO_FIN = 'assets/audios/countdown.wav';
  private  audio = new Audio();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private desafioPersonalProvider: DesafioPersonalProvider
  ) {

    this.jugador = navParams.get('jugador');
    this.equipo = navParams.get('equipo');
    this.juego = navParams.get('juego');
    this.bot = navParams.get('bot');

    if(!this.bot) {
      this.desafioPersonalProvider.setRondaActual({
        jugador: this.jugador,
        equipo: this.equipo,
        juego: this.juego
      });
    }
    

  }

  async ionViewDidLoad() {
    this.score = await this.authProvider.getScorePersonal();
    
    setTimeout( () => {
      this.iniciaContador();
      this.audio.src = this.AUDIO_FIN;
      this.audio.load();
      this.audio.play();
    }, 2500);
  }

  iniciaContador() {
    this.interval = setInterval(() => {
      this.count--;
      if(this.count === 0) {
        this.cancelaInterval();
        setTimeout( () => {
          this.navCtrl.setRoot(RetoPcPage, {
            juego: this.juego,
            jugador: this.jugador,
            equipo: this.equipo,
            bot: this.bot
          });
        }, 1000);
      }
    }, 1000);
  }

  cancelaInterval() {
    clearInterval(this.interval);
  }

}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/cargador-pc/cargador-pc.ts